import "core-js/stable";
import "regenerator-runtime/runtime";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import store, { history } from "@/store/store";
import App from "./App/App";
import { fetchCurrentUserThunk } from "./modules/user/userActions";
import { saveState } from "./localStorage";
import { unregister } from "./registerServiceWorker";

// set german locale for moment
import "moment/locale/de";
import type { Root } from "react-dom/client";

const { sessionToken } = store.getState();

// persist current state
store.subscribe(() => {
  saveState({
    // tickets: {
    //   readTicketsIds: store.getState().tickets.readTicketsIds,
    // },
    // estates: {
    //   currentEstate: store.getState().estates.currentEstate,
    // },
    sessionToken: store.getState().sessionToken,
    // propertyManagement: store.getState().propertyManagement,
  });
});

// initialize store only if the session token exists
if (!!sessionToken) {
  store.dispatch(fetchCurrentUserThunk());
}

// Bootstrapping: ensure the #root container exists before calling createRoot.
// In some environments the script may run before the DOM is ready, so
// guard and wait for DOMContentLoaded when necessary.
let rootInstance: Root | null = null;

function bootstrap(): void {
  const container = document.getElementById("root");
  if (!container) {
    // If container is still missing, log and bail out; the DOM may be
    // manipulated by other scripts. This prevents createRoot from throwing.
    console.error("React mount failed: #root element not found.");
    return;
  }

  if (!rootInstance) {
    rootInstance = createRoot(container);
    rootInstance.render(
      <Provider store={store}>
        {/* @ts-expect-error React Router v5 type incompatibility with React 18 */}
        <Router history={history}>
          <App />
        </Router>
      </Provider>,
    );
  }
}

if (typeof document !== "undefined" && document.readyState === "loading") {
  window.addEventListener("DOMContentLoaded", bootstrap, { once: true });
} else {
  bootstrap();
}

// Disable service worker until a proper version update mechanism is implemented
// registerServiceWorker();
unregister();
